var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfterpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.525 5.447-2.92-1.67-2.962-1.695C11.686.96 9.238 2.369 9.238 4.63v.38c0 .21.11.404.296.505l1.375.784a.57.57 0 0 0 .853-.497v-.902c0-.447.48-.726.869-.506l2.7 1.551 2.692 1.544a.578.578 0 0 1 0 1.003l-2.692 1.543-2.7 1.552a.582.582 0 0 1-.87-.506v-.447c0-2.26-2.447-3.677-4.404-2.547L4.395 9.781l-2.92 1.67c-1.967 1.13-1.967 3.972 0 5.102l2.92 1.67 2.962 1.695c1.957 1.121 4.405-.287 4.405-2.547v-.38c0-.21-.11-.404-.296-.506l-1.375-.784a.57.57 0 0 0-.853.498v.902a.582.582 0 0 1-.869.506l-2.7-1.552-2.692-1.543a.578.578 0 0 1 0-1.003l2.692-1.544 2.7-1.551c.388-.22.87.059.87.506v.447c0 2.26 2.447 3.676 4.404 2.546l2.962-1.695 2.92-1.67c1.967-1.138 1.967-3.971 0-5.101Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterpayLogo);
export default __webpack_public_path__ + "static/media/afterpay-logo.368c03897bd22fd4707f2d896f351ccf.svg";
export { ForwardRef as ReactComponent };